import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { ActionToastProvider } from './ActionToastProvider';

export { useActionToast } from './ActionToastProvider';
export type { ActionToastKind } from './actionToastKinds';

export const actionToastModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootWrapperBlueprint.make({
      name: 'action-toast',
      params: {
        component: ActionToastProvider,
      },
    }),
  ],
});
